import React from "react";

interface State { error?: Error }

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(err: Error, info: any) {
    // eslint-disable-next-line no-console
    console.error("UI error:", err, info);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto max-w-2xl px-4 py-12 text-center">
        <h1 className="mb-2 text-xl font-semibold text-red-700">
          Something went wrong · काहीतरी चूक झाली
        </h1>
        <p className="mb-4 text-sm text-slate-600">{this.state.error.message}</p>
        <button onClick={() => location.reload()}
          className="rounded bg-mhpol-900 px-4 py-2 text-sm text-white hover:bg-mhpol-700">
          Reload page
        </button>
      </div>
    );
  }
}

export function Skeleton({ rows = 3 }: { rows?: number }) {
  return (
    <div className="animate-pulse space-y-2 p-4">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-4 w-full rounded bg-slate-200" />
      ))}
    </div>
  );
}
